(() => {
  'use strict';
  if (window.DACFollowing) return;
  const element = document.getElementById('dac-following-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const copy = config.copy;
  let csrf, csrfAt = 0, authRequest, summary, version = 0;
  const sampleMode=!!config.allowDemo&&new URLSearchParams(location.search).get('af_demo')==='1'&&!!document.querySelector('[data-af-page],[data-af-dashboard-card]');
  const root = `${config.root.replace(/\/$/, '')}/`;
  const path = value => {
    const destination=root!=='/'&&value.startsWith(root)?value:root+value.replace(/^\//,'');
    const url = new URL(destination, location.origin);
    if(config.theme)url.searchParams.set('preview_theme_id',String(config.theme));
    if(sampleMode&&url.pathname===root+'pages/account')url.searchParams.set('af_demo','1');
    return url.href;
  };
  const sampleReady=sampleMode?import(config.sampleScript).then(module=>module.createDemo({copy,path,stylesheet:config.sampleStyle})):null;
  let toast, toastTimer;
  function announce(text) {
    if (!toast) { toast=document.createElement('div'); toast.className='dac-af-toast'; toast.setAttribute('role','status'); document.body.append(toast); }
    toast.textContent=text; toast.hidden=false; clearTimeout(toastTimer); toastTimer=setTimeout(()=>{toast.hidden=true;},6500);
  }
  function endpoint(query='') {
    const url=new URL(config.endpoint,location.origin);
    for(const [key,value] of new URLSearchParams(query))url.searchParams.set(key,value);
    url.searchParams.set('country',config.country);
    url.searchParams.set('_',String(Date.now()));
    return url;
  }
  async function readResponse(response) {
    const fallback=response.status===401||response.status===403?copy.signin_required:copy.error;
    if(!/\bapplication\/(?:[\w.-]+\+)?json\b/i.test(response.headers.get('content-type')||''))throw new Error(fallback);
    let result;try{result=await response.json();}catch{throw new Error(fallback);}
    if(!result||typeof result!=='object'||Array.isArray(result))throw new Error(fallback);
    if(!response.ok)throw new Error(typeof result.error==='string'?result.error:fallback);
    return result;
  }
  async function renew() {
    if(!authRequest)authRequest=(async()=>{
      const response=await fetch(endpoint('?view=session'),{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
      const result=await readResponse(response);if(!result.csrf)throw new Error(copy.signin_required);
      csrf=result.csrf;csrfAt=Date.now();
    })().finally(()=>{authRequest=null;});
    return authRequest;
  }
  async function api(query='',body,attempt=0) {
    if(sampleReady)return(await sampleReady).api(query,body);
    if(body&&(!csrf||Date.now()-csrfAt>1500000))await renew();
    let response;
    try {response=await fetch(endpoint(query),{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify({...body,csrf}):undefined,cache:'no-store',credentials:'same-origin',signal:AbortSignal.timeout(30000),keepalive:!!body});}
    catch(error){
      if(attempt<2&&error instanceof TypeError){await new Promise(resolve=>setTimeout(resolve,800*(attempt+1)));return api(query,body,attempt+1);}
      throw error;
    }
    if(response.status===403&&body&&!attempt){await renew();return api(query,body,1);}
    const result=await readResponse(response);
    if(result.csrf){csrf=result.csrf;csrfAt=Date.now();}
    return result;
  }
  function paintNotifications(data) {
    const count=data.unread, note=count===1?copy.menu_one_update:copy.menu_updates.replace('__COUNT__',count);
    document.querySelectorAll('[data-af-count]').forEach(badge=>{
      badge.hidden=!count;badge.textContent=count>99?'99+':String(count);badge.setAttribute('aria-label',note);
      if(badge.hasAttribute('data-af-header-count')){
        badge.textContent=count>9?'9+':String(count);
        const control=badge.closest('a,button');
        if(control){if(!control.dataset.afOriginalLabel)control.dataset.afOriginalLabel=control.getAttribute('aria-label')||'';control.setAttribute('aria-label',control.dataset.afOriginalLabel+(count?', '+note:''));}
      }
    });
    window.DACVoteNotifications?.paintHeader(count);
    document.querySelectorAll('[data-af-menu-link]').forEach(link=>{
      link.dataset.afUnread=String(count>0);link.href=path('pages/account?view=following');
      link.querySelector('[data-af-menu-note]').textContent=count?note:copy.menu_note;
      link.querySelector('[data-af-menu-note-compact]').textContent=count?(count===1?copy.menu_short_one:copy.menu_short_updates.replace('__COUNT__',count)):'';
    });
  }
  document.addEventListener('dac:following-mounted',()=>{if(summary)paintNotifications(summary);});
  function paint(data) {
    summary=data;
    const ids=new Set(data.artists.map(a=>a.id));
    document.querySelectorAll('[data-af-artist]').forEach(button=>{
      const followed=ids.has(button.dataset.afArtist);
      delete button.dataset.afUnknown;
      button.disabled=false; button.setAttribute('aria-pressed',String(followed));
      button.textContent=followed?copy.following:copy.follow;
      button.setAttribute('aria-label',(followed?copy.unfollow_name:copy.follow_name).replace('__NAME__',button.dataset.afName));
    });
    paintNotifications(data);
    document.dispatchEvent(new CustomEvent('dac:following-state',{detail:data}));
  }
  async function refresh() {
    const request=++version;
    const data=await api(`?view=summary${document.querySelector('[data-af-dashboard-card]')?'&preview_artists=1':''}`);
    if(request===version) paint(data);
    return data;
  }
  async function setFollow(id,enabled) {
    ++version;
    await api('',{action:'follow',artistId:id,enabled});
    await refresh();
    announce(enabled?copy.follow_saved:copy.unfollow_saved);
    document.dispatchEvent(new CustomEvent('dac:following-changed'));
  }
  document.addEventListener('click',async event=>{
    const intent=event.target.closest('[data-af-intent]');
    if(intent) {
      try {sessionStorage.setItem('dac-following-intent',intent.dataset.afIntent);}catch{}
      const login=new URL(intent.href),back=new URL(location.href);if(config.theme)back.searchParams.set('preview_theme_id',String(config.theme));
      login.searchParams.set('return_to',back.pathname+back.search);intent.href=login.href;return;
    }
    const button=event.target.closest('[data-af-artist]'); if(!button||button.disabled)return;
    if(button.dataset.afUnknown) {
      button.disabled=true;
      try{await refresh();}catch(error){button.disabled=false;announce(error.message);}return;
    }
    const enabled=button.getAttribute('aria-pressed')!=='true';
    button.disabled=true;button.textContent=copy.saving;
    try {await setFollow(button.dataset.afArtist,enabled);}
    catch(error) {button.disabled=false;button.dataset.afUnknown='true';button.textContent=copy.retry;button.setAttribute('aria-label',`${copy.retry}: ${button.dataset.afName}`);announce(error instanceof TypeError?copy.error:error.message);}
  });
  window.DACFollowing={api,copy,path,paint,refresh,setFollow,announce,get summary(){return summary;}};
  document.dispatchEvent(new Event('dac:following-ready'));
  if(config.signedIn) {
    let intent;if(!sampleMode)try{intent=sessionStorage.getItem('dac-following-intent');sessionStorage.removeItem('dac-following-intent');}catch{}
    const initial=intent?setFollow(intent,true):document.querySelector('[data-af-page]')?Promise.resolve():refresh();
    initial.catch(error=>{
      document.querySelectorAll('[data-af-artist]').forEach(b=>{b.disabled=false;b.dataset.afUnknown='true';b.textContent=copy.retry;b.setAttribute('aria-label',`${copy.retry}: ${b.dataset.afName}`);});
      document.dispatchEvent(new CustomEvent('dac:following-error',{detail:{message:copy.error}}));
      if(intent)announce(error.message);
    });
  }
})();
